import styled, { css } from 'styled-components';
import { getTrackBackground, Direction } from 'react-range';

import { backgroundShape } from '../../../stylesheets/tools';

const StyledRangeSlider = styled.div`
  .rangeSlider__track {
    ${props =>
      props.vertical &&
      css`
        width: 4px;
        height: 100%;
        background: ${getTrackBackground({
          values: props.values,
          colors: [props.theme.siteTheme.primary, '#fff'],
          min: props.min,
          max: props.max,
          direction: Direction.Up
        })};
      `}

    ${props =>
      !props.vertical &&
      css`
        height: 13px;
        width: 100%;
        border: solid 1px #fff;
      `}
  }

  .rangeSlider__thumb {
    position: relative;
    height: ${props => (!props.vertical ? '30px' : '20px')};
    width: ${props => (props.vertical ? '30px' : '20px')};
    margin-top: -1px;
    transform: translateX(-5px);
    ${backgroundShape('#fff')}

    &:before,
    &:after {
      position: absolute;
      content: '';
      background: #000;
    }

    ${props =>
      !props.vertical &&
      css`
        &:before,
        &:after {
          top: calc(50% - 4px);
          width: 2px;
          height: 8px;
        }

        &:before {
          left: 8px;
        }

        &:after {
          right: 6px;
        }
      `}

    ${props =>
      props.vertical &&
      css`
        ${backgroundShape(props.theme.siteTheme.primary)}

        &:before,
        &:after {
          left: calc(50% - 4px);
          height: 2px;
          width: 8px;
        }

        &:before {
          top: 8px;
        }

        &:after {
          bottom: 6px;
        }
      `}
  }
`;

export default StyledRangeSlider;
